import React, { useState, useEffect, Fragment } from "react"

import { ExpandLess, ExpandMore } from "@mui/icons-material"
import {
	List,
	ListItem,
	ListItemText,
	Checkbox,
	Collapse,
	Slider,
	FormGroup,
	FormControlLabel,
	Switch,
	Button,
	CircularProgress,
	Tooltip
} from "@mui/material"

import { 
	DemsSidebarBackdrop,
	DemsSidebar,
	DemsSidebarHeader,
	DemsSidebarTitle,
	DemsSidebarIcon,
	DemsSidebarWrapper,
	DemsSidebarContent,
	DemsSingleContent,
	SingleDemCounter,
	DemsSingleRow,
	DemSidebarCost,
	DemsSidebarFooter
 } from "./styles"

function DemPicker({
	demPickerOpen,
	onClose,

	selectedCategory,
	selectedDemographic,
	isDemLangLocal,
	setIsDemLangLocal,

	regions,
	estimateAudienceCost,
	demographicsHome,
	setDemographicsHome
}) {
	const [open, setOpen] = useState({})
	const [sidebarOpen, setSidebarOpen] = useState(false)
	const [openDemographic, setOpenDemographic] = useState({})
	const [sliderValues, setSliderValues] = useState({})
	const [isSliderMoving, setIsSliderMoving] = useState(false)
	const [committedDemographic, setCommittedDemographic] = useState(null)


	const [demographics, setDemographics] = useState([])
	const [loading, setLoading] = useState(true)
	const [estimateCost, setEstimateCost] = useState("")
	const [costLoading, setCostLoading] = useState(false)

	useEffect(() => {
		setDemographics(demographicsHome)
		setLoading(false)
	}, [demographicsHome])

	useEffect(() => {
		setCostLoading(true)

		const success = (data) => {
			setEstimateCost(data.cost_per_response)
			setCostLoading(false)
		}

		const error = (data) => {
			setCostLoading(false)
		}

		estimateAudienceCost(demographics, regions, success, error)
	
	}, [demographics, regions])


	const closeAndApplyDems = () => {
		setDemographicsHome(demographics)
		setSidebarOpen(false)
		setTimeout(() => {
			onClose()
		}, 500)

	}

						// const demographicRefs = data.reduce((acc, category) => {
					// 	category.demographics.forEach((demographic) => {
					// 		acc[demographic.id] = React.createRef()
					// 	})
					// 	return acc
					// }, {})


	// useEffect(() => {
	// 	if (
	// 		!isSliderMoving &&
	// 		!committedDemographic &&
	// 		demographicRefs[committedDemographic] &&
	// 		demographicRefs[committedDemographic].current
	// 	) {
	// 		demographicRefs[committedDemographic].current.scrollIntoView({
	// 			behavior: "smooth"
	// 		})
	// 	}
	// }, [committedDemographic, demographicRefs, isSliderMoving])

	useEffect(() => {
		if (selectedCategory) {
			setOpen((prevOpen) => ({
				...prevOpen,
				[selectedCategory]: true
			}))
		}
	}, [selectedCategory])

	useEffect(() => {
		if (selectedDemographic) {
			setOpenDemographic((prevOpen) => ({
				...prevOpen,
				[selectedDemographic]: true
			}))
		}
	}, [selectedDemographic])

	const handleClickCategory = (categoryId) => {
		setOpen((prevOpen) => ({
			...prevOpen,
			[categoryId]: !prevOpen[categoryId]
		}))
	}

	const handleDemographicClick = (demographicId) => {
		setOpenDemographic((prevOpen) => ({
			...prevOpen,
			[demographicId]: !prevOpen[demographicId]
		}))
	}

	const toggleAllDemographics = (categoryId, demographicId, selected) => {
		const updatedDemographics = demographics.map((category) => {
			if (category.id === categoryId) {
				const updatedDemographics = category.demographics.map((demographic) => {
					if (demographic.id === demographicId) {
						const updatedValues = demographic.demographic_values.map((value) => {
							return {
								...value,
								selected: selected
							}
						})
						return {
							...demographic,
							demographic_values: updatedValues
						}
					}
					return demographic
				})
				return {
					...category,
					demographics: updatedDemographics
				}
			}
			return category
		})
		setDemographics(updatedDemographics)
	}


	const handleCheckboxChange = (categoryId, demographicId, valueId) => {
		const updatedDemographics = demographics.map((category) => {
			if (category.id === categoryId) {
				const updatedDemographics = category.demographics.map((demographic) => {
					if (demographic.id === demographicId) {
						const updatedValues = demographic.demographic_values.map((value) => {
							if (value.id === valueId) {
								return {
									...value,
									selected: !value.selected
								}
							}
							return value
						})
						return {
							...demographic,
							demographic_values: updatedValues
						}
					}
					return demographic
				})
				return {
					...category,
					demographics: updatedDemographics
				}
			}
			return category
		})
		setDemographics(updatedDemographics)
	}

	const handleSliderChange = (categoryId, demographicId, newValue, comitted) => {
		const updatedDemographics = demographics.map((category) => {
			if (category.id === categoryId) {
				const updatedDemographics = category.demographics.map((demographic) => {
					if (demographic.id === demographicId) {
						const updatedValues = demographic.demographic_values.map((value) => {
							return {
								...value,
								selected: +value.text >= newValue[0] && +value.text <= newValue[1]
							}
						})
						return {
							...demographic,
							demographic_values: updatedValues
						}
					}
					return demographic
				})
				return {
					...category,
					demographics: updatedDemographics
				}
			}
			return category
		})

		// Update the slider values in the state
		setSliderValues((prevSliderValues) => ({
			...prevSliderValues,
			[demographicId]: newValue
		}))

		if (comitted) {
			setDemographics(updatedDemographics)
		}
	}

	useEffect(() => {
		if (demPickerOpen){
			setTimeout(() => {
				setSidebarOpen(true)
			}, 2)
		}

	},[demPickerOpen])

	return (
		<Fragment>
		<DemsSidebarBackdrop open={sidebarOpen} />
		<DemsSidebar open={sidebarOpen}>
			<DemsSidebarHeader>
				<DemsSidebarTitle>
					<div className="title">Select Demographics</div>
					<Tooltip title={'Display Local Language'} placement={'bottom'}>
					<FormGroup>
					<FormControlLabel
						control={<Switch color='primary' />}
						checked={isDemLangLocal}
						labelPlacement='start'
						// label='Display Local Language'
						value={isDemLangLocal}
						onChange={() => setIsDemLangLocal(!isDemLangLocal)}
					/>
				</FormGroup>
				</Tooltip>
				</DemsSidebarTitle>
			</DemsSidebarHeader>
			<DemsSidebarWrapper>
			<DemsSidebarContent>
			
			
			<List>
				{!loading && demographics.map((category) => (
					<div key={category.id}>
						<ListItem onClick={() => handleClickCategory(category.id)} sx={{ paddingLeft: 0, paddingRight: 0 }}>
								<ListItemText>
									<span style={{fontWeight: 500, fontSize: 15}}>
										{category.title}
									</span>
								</ListItemText>
								{open[category.id] ? <ExpandLess sx={{ color: '#9e9b9b' }} /> : <ExpandMore sx={{ color: '#9e9b9b' }} />}
							
						</ListItem>
						<Collapse in={open[category.id]} timeout='auto' unmountOnExit>
						<DemsSingleContent>
							<List component='div' disablePadding>
								{category.demographics.map((demographic) =>{ 
									
									const selectedDemographicsLength = demographic.demographic_values.filter((value) => value.selected).length
									
									return (
									
									<DemsSingleRow key={demographic.id}>
										<ListItem
											classes={{ root: 'Demographics' }}
											// ref={demographicRefs[demographic.id]}
											onClick={(event) => {
												event.stopPropagation() // Add this line
												handleDemographicClick(demographic.id)
											}}
											secondaryAction={
												<Checkbox
														checked={selectedDemographicsLength === demographic.demographic_values.length}
														indeterminate={selectedDemographicsLength !== 0 && selectedDemographicsLength < demographic.demographic_values.length}
														onChange={(event) => {
															event.stopPropagation()
															toggleAllDemographics(category.id, demographic.id, event.target.checked)
														
														}}
													/>
											}
										>
										<Fragment>
												<ListItemText>
													{!isDemLangLocal && demographic.override_en ? demographic.override_en : demographic.text}
													 {selectedDemographicsLength > 0 ? <SingleDemCounter>{selectedDemographicsLength}</SingleDemCounter> : null}
												</ListItemText>
												<DemsSidebarIcon>
													{openDemographic[demographic.id] ? <ExpandLess sx={{ color: '#9e9b9b' }} /> : <ExpandMore sx={{ color: '#9e9b9b' }} />}
												</DemsSidebarIcon>
											</Fragment>
										</ListItem>
										<Collapse in={openDemographic[demographic.id]} timeout='auto' unmountOnExit>
											<List component='div' disablePadding style={{ paddingLeft: "20px" }}>
												{demographic.format_id === 8 ? (
													<ListItem>
													<div style={{width: '90%'}}>
														<Slider
															disableSwap
															onMouseDown={() => setIsSliderMoving(true)}
															onMouseUp={() => setIsSliderMoving(false)}
															value={
																sliderValues[demographic.id] || [
																	Math.min(...demographic.demographic_values.map((value) => +value.text)),
																	Math.max(...demographic.demographic_values.map((value) => +value.text))
																]
															}
															onChange={(event, newValue) => {
																handleSliderChange(category.id, demographic.id, newValue, false)
															}}
															onChangeCommitted={(event, newValue) => {
																handleSliderChange(category.id, demographic.id, newValue, true)
																setCommittedDemographic(demographic.id)
															}}
															getAriaLabel={() => "Age Range"}
															valueLabelDisplay='auto'
															step={1}
															marks={[
																{ value: 20, label: "20" },
																{ value: 30, label: "30" },
																{ value: 40, label: "40" },
																{ value: 50, label: "50" },
																{ value: 60, label: "60" },
																{ value: 70, label: "70" },
																{ value: 80, label: "80" },
																{ value: 90, label: "90" }
															]}
															min={Math.min(...demographic.demographic_values.map((value) => +value.text))}
															max={Math.max(...demographic.demographic_values.map((value) => +value.text))}
														/>
														</div>
														
													</ListItem>
												) : (
													demographic.demographic_values.map((value) => (
														<ListItem 
															key={value.id}
															classes={{ root: 'Demographics' }}
															onClick={() => handleCheckboxChange(category.id, demographic.id, value.id)}
															secondaryAction={
																<Checkbox
																		checked={value.selected}
																		onChange={() => handleCheckboxChange(category.id, demographic.id, value.id)}
																	/>
															}
															>
															
																<ListItemText>
																	{!isDemLangLocal && value.override_en ? value.override_en : value.text}
																</ListItemText>
													
														</ListItem>
													))
												)}
											</List>
										</Collapse>
									</DemsSingleRow>
								)})}
							</List>
							</DemsSingleContent>
						</Collapse>
					</div>
				))}
			</List>
			</DemsSidebarContent>
			<DemsSidebarFooter>
			<DemSidebarCost>
			{costLoading ?
				<div style={{ marginTop: 8 }}>
					<CircularProgress color="inherit" size={20} />
				</div>
				:
				<div>
					{estimateCost}
					<span>per response</span>
				</div>
			}
	
			</DemSidebarCost>
			<Button style={{ marginRight: 8 }} size={'mediun'} onClick={() => { setSidebarOpen(false); setTimeout(() =>  onClose(), 500)}}>
			Cancel
			</Button>
			<Button variant='contained' size={'mediun'} onClick={closeAndApplyDems}>
			Ok
			</Button>
			</DemsSidebarFooter>
			</DemsSidebarWrapper>
		</DemsSidebar>
		</Fragment>
	)
}

export default DemPicker
